import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

const linksPorPerfil = {
  COLABORADOR: [
    { to: '/', label: 'Dashboard' },
    { to: '/metricas', label: 'Minhas Métricas' },
    { to: '/relatorios', label: 'Relatórios' },
  ],
  LIDER: [
    { to: '/', label: 'Dashboard' },
    { to: '/metricas', label: 'Métricas' },
    { to: '/colaboradores', label: 'Colaboradores' },
    { to: '/relatorios', label: 'Relatórios' },
  ],
  RH: [
    { to: '/', label: 'Dashboard' },
    { to: '/metricas', label: 'Métricas' },
    { to: '/colaboradores', label: 'Colaboradores' },
    { to: '/usuarios', label: 'Usuários' },
    { to: '/fechamento', label: 'Fechamento' },
    { to: '/relatorios', label: 'Relatórios' },
  ],
  GERENTE: [
    { to: '/', label: 'Dashboard' },
    { to: '/metricas', label: 'Métricas' },
    { to: '/colaboradores', label: 'Colaboradores' },
    { to: '/usuarios', label: 'Usuários' },
    { to: '/fechamento', label: 'Fechamento' },
    { to: '/relatorios', label: 'Relatórios' },
  ],
};

export function NavBar({ collapsed, visible, onCloseMobile, onToggleCollapse, mobile }) {
  const { auth, logout, perfil } = useAuth();
  const links = linksPorPerfil[perfil] || [];
  return (
    <aside className={"sidebar" + (collapsed ? ' collapsed':'' ) + (!visible ? ' hidden':'')}>
      <div className="sidebar-scroll">
        <div className="sidebar-header-block">
          <button className="collapse-btn" onClick={onToggleCollapse} aria-label={collapsed? 'Expandir menu':'Recolher menu'}>
            {collapsed ? <ArrowRight /> : <ArrowLeft />}
          </button>
        </div>
        {links.map(l => (
          <NavLink key={l.to} to={l.to} title={l.label} className={({isActive})=> 'nav-link' + (isActive ? ' active':'')} end onClick={onCloseMobile}>
            <span className="label">{l.label}</span>
          </NavLink>
        ))}
      </div>
      <div className="nav-footer" />
    </aside>
  );
}

function ArrowRight() {
  return (
    <svg className="arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M5 12h14" />
      <path d="M13 6l6 6-6 6" />
    </svg>
  );
}

function ArrowLeft() {
  return (
    <svg className="arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M19 12H5" />
      <path d="M11 18l-6-6 6-6" />
    </svg>
  );
}
